import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import RenderSelection from './renderSelection';
import { useTranslation } from 'react-i18next';

const Form = ({ 
  handleSubmit, 
  previous, 
  hasError, 
  recipients, 
  isFetching, 
  hasRecipients, 
  hasSpecificRecipient, 
  isSubmitting, 
  errors, 
  s 
}) => {
  const { t } = useTranslation('upload');
  const { control, register } = useFormContext();

  return (
    <form onSubmit={handleSubmit}>
      <h4 className={s['header']}>{t('recipient.form.header')}</h4>
      <p>{t('recipient.form.text')}</p>
      
      {!hasSpecificRecipient && (
        <div>
          {t('recipient.form.recipient1')}
          <strong>{t('recipient.form.recipient2')}</strong>
        </div>
      )}
      
      {isFetching && hasSpecificRecipient && (
        <span>{t('recipient.form.loading')}</span>
      )}
      
      {hasRecipients && hasSpecificRecipient && (
        <Controller
          name="recipient"
          control={control}
          rules={{ required: t('recipient.validate.error') }}
          render={({ field, fieldState: { error } }) => (
            <RenderSelection
              input={field}
              options={recipients}
              meta={{ 
                touched: !!error, 
                error: error?.message 
              }}
            />
          )}
        />
      )}
      
      {hasError && hasSpecificRecipient && (
        <div>{t('recipient.form.error')}</div>
      )}
      
      <div className={s['recipient-checkbox']}>
        <input
          {...register('specificRecipient')}
          id="specificRecipient"
          type="checkbox"
        />
        {' '}
        <label htmlFor="specificRecipient">
          {t('recipient.form.label')}
        </label>
      </div>
      
      <div className={s['footer']}>
        <button 
          className="btn btn--transparent" 
          type="button" 
          onClick={previous}
        >
          {t('recipient.form.returnButton')}
        </button>
        <button 
          type="submit" 
          className="btn btn--primary" 
          disabled={isSubmitting || isFetching || hasError || Object.keys(errors).length > 0}
        >
          {t('recipient.form.submitButton')}
        </button>
      </div>
    </form>
  );
};

export default Form;
